import React from 'react'
import { Row, Col } from 'antd'
import { translate } from 'react-i18next'
import { IconHelper } from '../../helpers'
import { Link } from 'react-router-dom'

const Error = ({t}) => {

    const { IconErrorMembership } = IconHelper

    return (
        <div>
            <section className="secMembership">
                <Row>
                    <Col span={24} className="success-title">
                        <h1>{t("modal_cancel_membership.error")}</h1>
                    
                    </Col>
                </Row>
                <Row type="flex" justify="center">
                    <Col xs={18} sm={16} md={16} lg={8}>
                        <div className="success-card">
                           <div className="icon-success">
                                <IconErrorMembership style={{marginTop: "20px"}}/>
                           </div>
                           <div className="tag-color">
                               {t("modal_cancel_membership.error_subject")}
                           </div>
                           <div className="text-detail">
                               {t("modal_cancel_membership.error_subject_detail")}
                               <p>{t("modal_cancel_membership.error_subject_detail_two")}</p>

                               <div className="back-to-history">
                                {t("modal_cancel_membership.back")} <Link to={"/portal/profile"} style={{color: "#FF0000"}}><u>{t("modal_cancel_membership.historyprivate")}</u></Link>
                                </div>
                           </div>
                           
                        </div>
                    </Col>
                </Row>
            </section>
        </div>
       
    )
}

export default translate()(Error)